export default {
    data() {
        return {
            loading: false,
            oldCount: null,
        };
    },
    computed: {
        notificationsCount() {
            return this.$store.state.notifications.count;
        },
        approvalRequest() {
            return this.$store.state.notifications.request;
        },
    },
    watch: {
        notificationsCount(count) {
            this.$root.setNotificationsCount(count);
        },
    },
    methods: {
        previewRecordChangeNotification(id) {
            return this.loadRecordChangeNotification(id);
        },
        loadRecordChangeNotification(id) {
            return axios
                .get(
                    route('api.v1.notifications.show', {
                        fields: '*,created_by.id,created_by.name,completed_by.id,completed_by.name',
                        notification: id,
                    })
                )
                .then((response) => {
                    const requestData = response.data.data.action_data.request || false;
                    this.$store.dispatch('notifications/setCurrent', response.data.data);
                    if (!requestData) {
                        return;
                    }
                    axios
                        .get(
                            route(`${requestData.getRoute}`, {
                                request: requestData.id,
                            })
                        )
                        .then((response) => {
                            const data = response.data.data;
                            this.$store.dispatch('notifications/setRequest', data);
                            switch (data.entity_class) {
                                case 'Bgo\\Consultants\\Data\\Entities\\Consultant':
                                    this.loadConsultant();
                                    break;
                                case 'Bgo\\Patients\\Data\\Entities\\Patient':
                                    this.loadPatient();
                                    break;
                                case 'Bgo\\Laboratories\\Data\\Entities\\Laboratory':
                                    this.loadLaboratory();
                                    break;
                                case 'Bgo\\CollectionCentres\\Data\\Entities\\CollectionCentre':
                                    this.loadCollectionCentre();
                                    break;
                                case 'Bgo\\PharmacySites\\Data\\Entities\\PharmacySite':
                                    this.loadPharmacySite();
                                    break;
                                case 'Bgo\\PharmacyGroups\\Data\\Entities\\PharmacyGroup':
                                    this.loadPharmacyGroups();

                                    break;
                                default:
                                    break;
                            }
                        });
                });
        },
        loadPharmacyGroups() {
            const id = this.approvalRequest.entity_id;
            const newValues = this.approvalRequest.new_values || new Object();
            const oldValues = this.approvalRequest.old_values || new Object();
            this.$store.dispatch('pharmacy_groups/loadPharmacyOptions');
            const isNewRecord = !id;
            const updatedProps = new Array();
            Object.keys(newValues).forEach((key) => {
                // if (key === 'npt_device') {
                //     Object.assign(newValues, { npt_device_id: newValues.npt_device });
                //     updatedProps.push(`npt_device_id`);
                // }
                if (_.isObject(newValues[key])) {
                    Object.keys(newValues[key]).forEach((subKey) => {
                        return updatedProps.push(`${key}.${subKey}`);
                    });
                    return;
                }
                return updatedProps.push(`${key}`);
            });
            if (isNewRecord) {
                const data = _.clone(newValues);
                this.$store.dispatch('notification_pharmacy_group/loadPharmacyGroupSnapShot', data);
                this.$store.dispatch('notification_pharmacy_group/setUpdatedProps', updatedProps);
            }
            if (!isNewRecord) {
                axios
                    .get(
                        route('api.v1.pharmacy-groups.show', {
                            pharmacy_group: id,
                            fields: '*,pharmacy_sites',
                        })
                    )
                    .then((response) => {
                        const data = _.clone(response.data.data);
                        const oldDataMerge = new Object(Object.assign({}, data, oldValues));
                        this.$store.dispatch('notification_pharmacy_group/loadPharmacyGroup', oldDataMerge);
                        const dataMerge = new Object(Object.assign({}, data, newValues));
                        this.$store.dispatch('notification_pharmacy_group/loadPharmacyGroupSnapShot', dataMerge);
                        this.$store.dispatch('notification_pharmacy_group/setUpdatedProps', updatedProps);
                    })
                    .catch((error) => {
                        this.$root.notify('error', error.message);
                    });
                return;
            }
        },
        loadPharmacySite() {
            const id = this.approvalRequest.entity_id;
            const newValues = this.approvalRequest.new_values || new Object();
            const oldValues = this.approvalRequest.old_values || new Object();
            this.$store.dispatch('pharmacy_sites/loadPharmacyOptions');
            this.$store.dispatch('pharmacy_sites/loadBloodProvidersOptions');
            const isNewRecord = !id;
            const updatedProps = new Array();
            Object.keys(newValues).forEach((key) => {
                // if (key === 'npt_device') {
                //     Object.assign(newValues, { npt_device_id: newValues.npt_device });
                //     updatedProps.push(`npt_device_id`);
                // }
                // if (_.isObject(newValues[key])) {
                //     Object.keys(newValues[key]).forEach((subKey) => {
                //         return updatedProps.push(`${key}.${subKey}`);
                //     });
                //     return;
                // }
                return updatedProps.push(`${key}`);
            });
            if (isNewRecord) {
                const data = _.clone(newValues);
                this.$store.dispatch('notification_pharmacy_site/loadPharmacySiteSnapShot', data);
                this.$store.dispatch('notification_pharmacy_site/setUpdatedProps', updatedProps);
            }
            if (!isNewRecord) {
                axios
                    .get(
                        route('api.v1.pharmacy-sites.show', {
                            pharmacy_site: id,
                            fields: '*,pharmacy_groups,blood_result_providers',
                        })
                    )
                    .then((response) => {
                        const data = _.clone(response.data.data);
                        const oldDataMerge = new Object(Object.assign({}, data, oldValues));
                        this.$store.dispatch('notification_pharmacy_site/loadPharmacySite', oldDataMerge);
                        const dataMerge = new Object(Object.assign({}, data, newValues));
                        this.$store.dispatch('notification_pharmacy_site/loadPharmacySiteSnapShot', dataMerge);
                        this.$store.dispatch('notification_pharmacy_site/setUpdatedProps', updatedProps);
                    })
                    .catch((error) => {
                        this.$root.notify('error', error.message);
                    });
                return;
            }
        },
        loadCollectionCentre() {
            const id = this.approvalRequest.entity_id;
            const newValues = this.approvalRequest.new_values || new Object();
            const oldValues = this.approvalRequest.old_values || new Object();
            const isNewRecord = !id;
            const updatedProps = new Array();
            Object.keys(newValues).forEach((key) => {
                if (key === 'npt_device') {
                    Object.assign(newValues, { npt_device_id: newValues.npt_device });
                    updatedProps.push(`npt_device_id`);
                }
                if (_.isObject(newValues[key])) {
                    Object.keys(newValues[key]).forEach((subKey) => {
                        return updatedProps.push(`${key}.${subKey}`);
                    });
                    return;
                }
                return updatedProps.push(`${key}`);
            });
            if (isNewRecord) {
                const data = _.clone(newValues);
                this.$store.dispatch('laboratories/loadCollectionCentreSnapShot', data);
                this.$store.dispatch('laboratories/setUpdatedProps', updatedProps);
            }
            if (!isNewRecord) {
                axios
                    .get(
                        route('api.v1.providers.show', {
                            blood_result_provider: id,
                            fields: '*,type',
                        })
                    )
                    .then((response) => {
                        const data = {
                            formToSet: 'collection_centre',
                            data: new Object(Object.assign({}, _.clone(response.data.data), oldValues)),
                        };
                        this.$store.dispatch('notification_laboratory/loadDataForForm', data);
                        const dataMerge = new Object(Object.assign({}, data.data, newValues));
                        this.$store.dispatch('notification_laboratory/loadCollectionCentreSnapShot', dataMerge);
                        this.$store.dispatch('notification_laboratory/setUpdatedProps', updatedProps);
                    })
                    .catch((error) => {
                        this.$root.notify('error', error.message);
                    });
                return;
            }
        },
        loadLaboratory() {
            const id = this.approvalRequest.entity_id;
            const newValues = this.approvalRequest.new_values || new Object();
            const oldValues = this.approvalRequest.old_values || new Object();
            this.$store.dispatch('notification_laboratory/loadNPTDevicesOptions', { id });
            const isNewRecord = !id;
            const updatedProps = new Array();
            Object.keys(newValues).forEach((key) => {
                if (key === 'npt_device') {
                    Object.assign(newValues, { npt_device_id: newValues.npt_device });
                    updatedProps.push(`npt_device_id`);
                }
                if (_.isObject(newValues[key])) {
                    Object.keys(newValues[key]).forEach((subKey) => {
                        return updatedProps.push(`${key}.${subKey}`);
                    });
                    return;
                }
                return updatedProps.push(`${key}`);
            });
            if (isNewRecord) {
                const data = _.clone(newValues);
                this.$store.dispatch('notification_laboratory/loadLaboratorySnapShot', data);
                this.$store.dispatch('notification_laboratory/setUpdatedProps', updatedProps);
            }
            if (!isNewRecord) {
                axios
                    .get(
                        route('api.v1.providers.show', {
                            blood_result_provider: id,
                            fields: '*,type',
                        })
                    )
                    .then((response) => {
                        const data = {
                            formToSet: 'laboratory',
                            data: new Object(Object.assign({}, _.clone(response.data.data), oldValues)),
                        };
                        const oldDataMerge = new Object(Object.assign({}, data, oldValues));
                        this.$store.dispatch('notification_laboratory/loadDataForForm', oldDataMerge);
                        const dataMerge = new Object(Object.assign({}, data.data, newValues));
                        this.$store.dispatch('notification_laboratory/loadLaboratorySnapShot', dataMerge);
                        this.$store.dispatch('notification_laboratory/setUpdatedProps', updatedProps);
                    })
                    .catch((error) => {
                        this.$root.notify('error', error.message);
                    });
                return;
            }
        },
        loadConsultant() {
            const id = this.approvalRequest.entity_id;
            const newValues = this.approvalRequest.new_values || new Object();
            const oldValues = this.approvalRequest.old_values || new Object();
            const isNewRecord = !id;
            const updatedProps = new Array();
            Object.keys(newValues).forEach((key) => {
                if (_.isObject(newValues[key])) {
                    Object.keys(newValues[key]).forEach((subKey) => {
                        return updatedProps.push(`${key}.${subKey}`);
                    });
                    return;
                }
                return updatedProps.push(`${key}`);
            });

            if (isNewRecord) {
                const data = _.clone(newValues);
                this.$store.dispatch('notification_consultant/loadConsultantSnapShot', data);
                this.$store.dispatch('notification_consultant/setUpdatedProps', updatedProps);
            }
            if (!isNewRecord) {
                axios
                    .get(
                        route('api.v1.consultants.show', {
                            consultant: id,
                        })
                    )
                    .then((response) => {
                        const data = _.clone(response.data.data);
                        const oldDataMerge = new Object(Object.assign({}, data, oldValues));
                        this.$store.dispatch('notification_consultant/loadConsultant', oldDataMerge);
                        const dataMerge = new Object(Object.assign({}, data, newValues));
                        this.$store.dispatch('notification_consultant/loadConsultantSnapShot', dataMerge);
                        this.$store.dispatch('notification_consultant/setUpdatedProps', updatedProps);
                    })
                    .catch((error) => {
                        this.$root.notify('error', error.message);
                    });
                return;
            }
        },
        loadPatient() {
            const id = this.approvalRequest.entity_id;
            const newValues = this.approvalRequest.new_values || new Object();
            const oldValues = this.approvalRequest.old_values || new Object();
            this.$store.dispatch('patients/loadPharmacyOptions');
            this.$store.dispatch('patients/loadConsultantOptions');
            this.$store.dispatch('patients/loadBloodProvidersOptions');
            this.$store.dispatch('patients/loadPatientStatusOptions');
            this.$store.dispatch('patients/loadCCOptions');
            const isNewRecord = !id;
            const updatedProps = new Array();
            Object.keys(newValues).forEach((key) => {
                if (key === 'consultant') {
                    Object.assign(newValues, { consultant_id: newValues.consultant });
                    updatedProps.push(`consultant_id`);
                }
                if (key === 'pharmacy_site') {
                    Object.assign(newValues, { pharmacy_site_id: newValues.pharmacy_site });
                    updatedProps.push(`pharmacy_site_id`);
                }
                if (_.isObject(newValues[key])) {
                    Object.keys(newValues[key]).forEach((subKey) => {
                        return updatedProps.push(`${key}.${subKey}`);
                    });
                    return;
                }
                return updatedProps.push(`${key}`);
            });
            if (isNewRecord) {
                const data = _.clone(newValues);
                this.$store.dispatch('notification_patient/loadPatientSnapShot', data);
                this.$store.dispatch('notification_patient/setUpdatedProps', updatedProps);
                return;
            }
            if (!isNewRecord) {
                axios
                    .get(
                        route('api.v1.patients.show', {
                            patient: id,
                            fields: '*,diagnosis,has_treatment_break,health_information,color,validity_date,name,first_blood_sample_date,last_blood_sample_date,next_due_date,blood_testing_frequency',
                        })
                    )
                    .then((response) => {
                        const data = _.clone(response.data.data);
                        const oldDataMerge = new Object(Object.assign({}, data, oldValues));
                        oldDataMerge.health_information = Object.assign(
                            {},
                            data.health_information,
                            oldValues.health_information
                        );
                        oldDataMerge.diagnosis = Object.assign({}, data.diagnosis, oldValues.diagnosis);
                        this.$store.dispatch('notification_patient/loadPatient', oldDataMerge);
                        this.$store.dispatch('notification_patient/loadAddress');
                        const dataMerge = new Object(Object.assign({}, data, newValues));
                        dataMerge.health_information = Object.assign(
                            {},
                            data.health_information,
                            newValues.health_information
                        );
                        dataMerge.diagnosis = Object.assign({}, data.diagnosis, newValues.diagnosis);
                        this.$store.dispatch('notification_patient/loadPatientSnapShot', dataMerge);
                        this.$store.dispatch('notification_patient/setUpdatedProps', updatedProps);
                    })
                    .catch((error) => {
                        this.$root.notify('error', error.message);
                    });
                return;
            }
        },
        async loadNotification(id) {
            return await axios
                .get(
                    route('api.v1.notifications.show', {
                        notification: id,
                        fields: 'id,status,memo,created_at,type,created_by.id,created_by.name,action_data,status',
                    })
                )
                .then((response) => {
                    this.$store.dispatch('notifications/setCurrent', response.data.data);
                });
        },
        async markAllAsCompleted() {
            this.loading = true;
            return await axios
                .put(route('api.v1.notifications.complete.bulk'))
                .then(() => {
                    this.$store.dispatch('notifications/fetchNotifications');
                    this.$root.notify(
                        'info',
                        t('notifications::notification.title.marked_as_completed'),
                        t('notifications::notification.text.marked_all_as_completed')
                    );
                })
                .finally(() => _.delay(() => (this.loading = false), 400));
        },
        async markAsCompleted(item) {
            this.loading = true;
            return await axios
                .put(
                    route('api.v1.notifications.complete', {
                        notification: item.id,
                    })
                )
                .then(() => {
                    this.$store.dispatch('notifications/fetchNotifications');
                    this.$root.notify(
                        'info',
                        t('notifications::notification.title.marked_as_completed'),
                        t('notifications::notification.text.marked_as_completed')
                    );
                })
                .finally(() => _.delay(() => (this.loading = false), 400));
        },
        preview(item) {
            if (!item && !item.id) {
                return;
            }
            if (item.type && item.type === 'record_changes') {
                return this.previewRecordChangeNotification(item.id).then(() => (this.previewModal = true));
            }
            return this.loadNotification(item.id).then(() => (this.previewModal = true));
        },
        getNotifications() {
            this.$store.dispatch('notifications/initWebsocket');
            this.$store.dispatch('notifications/fetchNotifications');
        },
        prepareNotification(notifications) {
            if (!notifications.length) {
                return [];
            }
            notifications.forEach((notification) => {
                // notification.date = this.prepareNotificationDateDiff(notification.date);
                notification.date = notification.date
                    ? moment(notification.date, this.$root.dateFormatWithHours)
                    : false;
                this.setColor(notification);
                _.set(notification, 'class', `notification ${notification.status} color-${notification.color}`);
            });
        },
        prepareNotificationDateDiff(date) {
            const diffObj = moment.duration(new moment().diff(date));
            const diff = [];
            if (!diffObj._isValid) {
                return false;
            }
            !!diffObj._data.years && diffObj._data.years > 0 ? diff.push(`${diffObj._data.years} year,`) : false;
            !!diffObj._data.months && diffObj._data.months > 0 ? diff.push(`${diffObj._data.months} month,`) : false;
            !!diffObj._data.days && diffObj._data.days > 0 ? diff.push(`${diffObj._data.days} day,`) : false;
            !!diffObj._data.hours && diffObj._data.hours > 0 ? diff.push(`${diffObj._data.hours} hr,`) : false;
            !!diffObj._data.minutes && diffObj._data.minutes > 0 ? diff.push(`${diffObj._data.minutes} min`) : false;
            return diff.join(' ');
        },
        setColor(item) {
            switch (item.type) {
                case 'blood_result':
                    _.set(item, 'color', 'red');
                    break;
                case 'adverse_event':
                    _.set(item, 'color', 'amber');
                    break;
                case 'record_changes':
                    _.set(item, 'color', 'blue');
                    break;
                default:
                    _.set(item, 'color', 'blue');
                    break;
            }
        },
        goTo(route, param = null) {
            if (param) {
                return this.$root.goTo(this.$root.route(route, param ? param : false));
            }
            return this.$root.goTo(this.$root.route(route));
        },
    },
};
